import React from "react";
import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import "./OurReleases.css";

const releases = [
  {
    number: "01",
    label: "Product release",
    title: "Indigenously developed sealing solutions",
    description: "Explore our range of piston rod seals, metallic face seals and engineered assemblies.",
    link: "/indigenously-developed-assemblies",
  },
  {
    number: "02",
    label: "Capability update",
    title: "Precision manufacturing capabilities",
    description: "Discover how our machinery, people and quality systems support critical components.",
    link: "/capabilities",
  },
  {
    number: "03",
    label: "Engineering insight",
    title: "Research, testing and quality",
    description: "Learn about the processes behind consistent, reliable performance across industries.",
    link: "/research",
  },
];

const OurReleases = () => (
  <section className="our-releases" aria-labelledby="our-releases-title">
    <div className="our-releases__heading">
      <p className="our-releases__eyebrow">Latest from Hardcoats</p>
      <h2 id="our-releases-title">Our releases</h2>
      <p>New products, capabilities and engineering stories from our team.</p>
    </div>
    <div className="our-releases__list">
      {releases.map((release) => (
        <Link className="release-card" to={release.link} key={release.number}>
          <span className="release-card__number">{release.number}</span>
          <div>
            <span className="release-card__label">{release.label}</span>
            <h3>{release.title}</h3>
            <p>{release.description}</p>
          </div>
          <ArrowUpRightIcon className="release-card__arrow" />
        </Link>
      ))}
    </div>
  </section>
);

export default OurReleases;
